/**
 * Lazy load handling for owl carousel
 */
function itemIndex(index, total) {
    return (index + total) % total;
}

function init(owlCarousel) {
    owlCarousel.on('translated.owl.carousel', function(event) {
        var $carousel = $(this),
            options = $carousel.data('options');

        if (options && !options.owlLazy) {
            return;
        }

        var totitem = event.item.count;
        var index = $(event.target).find('.owl-item.active .item').data('index');
        var nextitems = [
            itemIndex(index - 1, totitem),
            itemIndex(index, totitem),
            itemIndex(index + 1, totitem)

        ];
        nextitems.forEach(function(nextitem) {
            var items = $(event.target).find('[data-index="' + nextitem + '"]').find('[data-src]');
            for(var i=0; i<items.length; i++) {
                var item = $(items[i]);
                if (!item.data('cached') && item.data('src')) {
                    item.css({'background-image': 'url(' + item.data('src') + ')'})
                        .data('cached', true);
                }
            }
        });
    });
}

module.exports = init;



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/owl-carousel-lazy.js
// module id = 47
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17